export const endpoint = {
  activity: {
    retrieve: 'activity/{id}/groups/{groupId}',
    studentRetrieve: 'activity/{id}/groups/{groupId}/students/{studentId}',
    rubrics: 'activity/{id}/rubrics',
    features: {
      retrieve: 'activity/{id}/groups/{groupId}/features',
      student: 'activity/{id}/groups/{groupId}/students/{studentId}/features',
      selectedStudentsTag: 'activity/{id}/groups/{groupId}/feature/{featureName}',
      save: 'activity/{id}/groups/{groupId}/feature',
      studentSave: 'activity/{id}/groups/{groupId}/students/{studentId}/feature',
      exercise: 'activity/{id}/groups/{groupId}/exercise/{exerciseId}/feature',
    },
    student: {
      grades: 'activity/{id}/groups/{groupId}/students/{studentId}/subcompetence-assessments',
      answers: 'activity/{id}/groups/{groupId}/students/{studentId}/answers',
      averageGrades: 'activity/{id}/groups/{groupId}/students/{studentId}/page-average-grades',
      state: 'activity/{id}/groups/{groupId}/students/{studentId}/state',
      status: 'activity/{id}/groups/{groupId}/students/state',
      allStudentsSubcompetences: 'activity/{id}/groups/{groupId}/students/subcompetences-assessments',
      multiAnswers: 'activity/{id}/groups/{groupId}/students/{studentId}/score',
      solutionary: 'activity/{id}/exercise/{exerciseId}/groupId/{groupId}/studentId/{studentId}/solutionary',
    },
    teacher: {
      guide: 'activity/{id}/exercise/{exerciseId}/teacher-guide',
      solutionary: 'activity/{id}/exercise/{exerciseId}/solutionary',
      averageGrades: 'activity/{id}/groups/{groupId}/page-average-grades',
    },
    step: {
      stepsStudent: 'steps/{id}/groups/{groupId}/activities',
      teachingInfo: 'activity/{id}/teaching-info',
      resources: 'steps/{stepId}/groups/{groupId}/students/{studentId}/resources',
    },
    materials: {
      retrieve: 'activity/{id}/groups/{groupId}/materials',
    },
    evaluate: {
      repeatActivity: 'activity/{id}/groups/{groupId}/students/{studentId}/repeat-activity',
    },
    progress: {
      get: 'activity/{activityId}/groups/{groupId}/students/{studentId}/exercises-progress',
    },
  },
  group: {
    retrieve: 'groups',
    userGroupsByYear: 'academic-years/{academicYearId}/user-groups',
    groupsByYear: 'academic-years/{academicYearId}/groups',
    groupById: 'groups/{id}',
    licenses: 'academic-year/{academicYearId}/licenses',
    teachers: {
      get: 'teachers',
      byAcademicYear: 'teachers/{academicYearId}/groups',
      delete: 'teachers/teacher/{teacherId}',
    },
    students: {
      delete: 'groups/{groupId}/students/{studentId}',
      invite: 'groups/{groupId}/students',
    },
    itineraries: {
      group: 'itineraries/group/{groupId}',
      modify: 'itineraries/{id}/group/{groupId}/reorder-steps',
      setCurrentStep: 'itineraries/group/{groupId}/steps/{stepId}/is-current',
      setCompletedStep: 'itineraries/group/{groupId}/steps/{stepId}/is-complete',
      setHiddenStep: 'itineraries/group/{groupId}/steps/{stepId}/is-hidden',
      rollback: 'itineraries/{id}/group/{groupId}/reset',
      tekman: 'itineraries/onmat/{itineraryId}',
      tekmanPost: 'itineraries/onmat/group/{itineraryId}',
      onmatDefault: 'itineraries/onmat/courses/{courseId}?type={type}',
    },
    classes: {
      reSendInvitationStudents: 'students/resend-invitations',
      reSendInvitationTeachers: 'teachers/resend-invitations',
      delete: 'groups/{groupId}',
    },
    progress: 'groups/{groupId}/user-progress',
  },
  user: {
    profile: 'profile',
    updatePassword: 'students/{id}/password',
    updateInfo: 'students/{id}/name',
  },
  resources: {
    selfAssessment: 'resources/self-assessment',
    didacticSecuence: 'resources/didactic-sequence/course/{courseId}',
    materials: 'resources/courses/{id}/materials/{name}',
    materialsByStep: 'resources/step/{step}/materials/teacher_guide',
  },
  mixpanel: {
    identify: 'analytics/mixpanel/people',
  },
  hubspot: {
    identify: 'analytics/hubspot/token',
  },
  evaluation: {
    export: 'assessment/statement/request-zero/groups/{groupId}',
  },
  itineraries: {
    step: {
      retrieve: 'itinerary/{itineraryId}/steps/{stepId}/groups/{groupId}/sessions',
      update: 'itineraries/{itineraryId}/group/{groupId}/steps/{stepId}',
      evaluationItems: 'steps/{stepId}/groups/{groupId}/evaluation-instruments',
      otherActivities: 'itineraries/{itineraryId}/steps/{stepId}/groups/{groupId}/other-activities',
      qualifications: {
        create: 'assessment/statement/groups/{id}/step/{stepId}/excel-create',
        status: 'assessment/statement/groups/{id}/step/{stepId}/excel-status',
        download: 'assessment/statement/groups/{id}/step/{stepId}/excel-download',
      },
    },
    qualifications: {
      create: 'assessment/statement/groups/{id}/excel-create',
      status: 'assessment/statement/groups/{id}/excel-status',
      download: 'assessment/statement/groups/{id}/excel-download',
      getByQuarter: 'groups/{id}/tracking/time-periods',
      getBySense: 'groups/{id}/tracking/content-blocks',
      getStudentByQuarter: 'groups/{groupId}/tracking/students/{studentId}/time-periods',
      getStudentBySense: 'groups/{groupId}/tracking/students/{studentId}/content-blocks',
      getTrackingStep: 'groups/{groupId}/tracking/steps/{stepId}/detail',
    },
  },
  courses: {
    retrieve: 'courses',
    blocks: 'courses/{courseId}/groups/{groupId}/steps',
    steps: 'steps/{stepId}/groups/{groupId}/activities',
    stepsExtra: 'content-blocks/{id}/courses/{id}/groups/{id}/step-activities',
  },
  external: {
    accessTokenExtraInfo: 'https://www.googleapis.com/oauth2/v1/tokeninfo?access_token={accessToken}',
    classroomUserInfo: 'https://classroom.googleapis.com/v1/userProfiles/{userId}',
    classroomCourses: 'https://classroom.googleapis.com/v1/courses',
    classroomStudents: 'https://classroom.googleapis.com/v1/courses/{courseId}/students',
    classroomTeachers: 'https://classroom.googleapis.com/v1/courses/{courseId}/teachers',
    teamsGraphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
    teamsGraphMailEndpoint: 'https://graph.microsoft.com/v1.0/me/messages',
    teamsGraphJoinedTeams: 'https://graph.microsoft.com/v1.0/me/joinedTeams',
    teamsStudents: 'https://graph.microsoft.com/v1.0/groups/{classId}/members',
    teamsOwners: 'https://graph.microsoft.com/v1.0/groups/{classId}/owners',
  },
};
